import { render } from "./testimonials.vue?vue&type=template&id=7e1a715b&scoped=true"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"

import "./testimonials.vue?vue&type=style&index=0&id=7e1a715b&scoped=true&lang=css"

import exportComponent from "C:\\blissappp\\theblissholidays\\bliss-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1a715b"]])

export default __exports__